/**
 * Lit un paramètre d'URL précis (décodé).
 * Retourne '' si absent.
 */
export function getUrlParameter(name: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get(name) ?? '';
}

/**
 * Retourne tous les paramètres d'URL sous forme d'objet clé/valeur.
 * Valeurs sont décodées. Les clés dupliquées ne prennent que la première occurrence.
 */
export function getAllUrlParameters(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};
  for (const [key, value] of params.entries()) {
    if (!(key in result)) {
      result[key] = value;
    }
  }
  return result;
}
